import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const ToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 32px;
  padding: 0 ${props => props.theme.spacing.sm};
  font-size: ${props => props.theme.typography.fontSize.xs};
  font-weight: ${props => props.theme.typography.fontWeight.semibold};
  font-family: inherit;
  letter-spacing: 0.02em;
  color: ${props => props.theme.colors.text.primary};
  background: ${props => props.theme.colors.background.secondary};
  border: 1px solid ${props => props.theme.colors.border.light};
  border-radius: 6px;
  cursor: pointer;
  transition: opacity ${props => props.theme.transitions.base}, border-color ${props => props.theme.transitions.base};
  white-space: nowrap;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    min-height: 28px;
    padding: 0 7px;
    font-size: 0.7rem;
    letter-spacing: 0;
  }

  &:hover {
    opacity: 0.85;
    border-color: ${props => props.theme.colors.black};
  }
`;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const isAr = i18n.language.startsWith('ar');

  const toggle = () => {
    void i18n.changeLanguage(isAr ? 'en' : 'ar');
  };

  /** Current UI is Arabic → offer English. Current UI is English → offer Arabic (label "Ar"). */
  const label = isAr ? 'En' : 'Ar';
  const ariaLabel = isAr ? 'Switch to English' : 'Switch to Arabic';

  return (
    <ToggleBtn type="button" onClick={toggle} aria-label={ariaLabel}>
      {label}
    </ToggleBtn>
  );
};

export default LanguageSwitcher;
